import { InvoiceFormData, VetdataInvoiceData } from '@/types/LieferantRechnungFormularDtos';
import { RechnungFormularApiDto } from '@/api-schema';

export class InvoiceSubmissionHelper {
    // Build submission request
    public static async buildSubmissionRequest(xmlString: string, pdfFile: File | null, formData: InvoiceFormData): Promise<RechnungFormularApiDto> {
        // Create Blob for XML data
        const xmlBlob = new Blob([xmlString], { type: 'application/xml' });

        // Use the provided PDF or create a fallback/mock if null
        const pdfBlob =
            pdfFile ||
            new Blob(
                [
                    '%PDF-1.4\n1 0 obj\n<< /Type /Catalog /Pages 2 0 R >>\nendobj\n2 0 obj\n<< /Type /Pages /Kids [3 0 R] /Count 1 >>\nendobj\n3 0 obj\n<< /Type /Page /Parent 2 0 R /MediaBox [0 0 612 792] >>\nendobj\nxref\n0 4\n0000000000 65535 f\n0000000009 00000 n\n0000000058 00000 n\n0000000115 00000 n\ntrailer\n<< /Size 4 /Root 1 0 R >>\nstartxref\n190\n%%EOF'
                ],
                { type: 'application/pdf' }
            );

        return {
            tvsCustomerNumber: parseInt(formData.tvsCustomerNumber),
            documentIdentifier: parseInt(formData.documentIdentifier),
            documentIssueDate: formData.documentIssueDate, // mapping rechnungsdatum
            xmlData: xmlBlob as any,
            pdfData: pdfBlob as any
        };
    }

    // Pre-submission validation
    public static validateInvoiceData(data: VetdataInvoiceData): { valid: boolean; errors: string[] } {
        const errors: string[] = [];

        // Validate positions
        if (data.positions.length === 0) {
            errors.push('At least one position is required');
        }
        return {
            valid: errors.length === 0,
            errors
        };
    }
}
